module.exports = __webpack_public_path__ + "img/index_02.f5b67996.jpg";